import React, { useEffect, useRef } from 'react';
import '@toast-ui/editor/dist/toastui-editor-viewer.css'; 
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer'; 

const TextViewer = ({ content }) => {
    const viewerRef = useRef(null);

    const formatContent = (content) => {
        // const baseUrl = process.env.REACT_APP_BACKEND_URL; 
        return content.replace(/!\[.*?\]\((?!http)(.*?)\)/g, (match, filePath) => {
            return match.replace(filePath, `${filePath}`);
        });
    };

    useEffect(() => {
        const viewerInstance = new Viewer({
            el: viewerRef.current,
            initialValue: formatContent(content), 
        });

        return () => {
            viewerInstance.destroy();
        };
    }, [content]);

    return (
        <div
            ref={viewerRef}
            className="form-conts"
            style={{ width: '100%', wordBreak: 'break-word' }}
        ></div>
    );
};

export default TextViewer;
